import Vue from 'vue'
import {
  Button,
  Select,
  Option,
  Tree,
  Input,
  Drawer,
  MessageBox,
  Message,
  Form,
  FormItem,
  Dialog,
  Table,
  TableColumn,
  Radio
} from 'element-ui'
import App from './App.vue'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/base.css'
import router from './router/index'
import TEditor from '@/components/TinyEditor/Index.vue'

import { getDate } from './utils/helper'

Vue.component('TEditor', TEditor)

Vue.config.productionTip = false

Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Tree)
Vue.use(Input)
Vue.use(Drawer)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Dialog)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Radio)

Vue.prototype.$msgbox = MessageBox
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// 时间戳转年月日
Vue.filter('get_date', date => {
  return getDate('yyyy-mm-dd', date)
})
